import React from "react";
import { Route, Redirect, RouteProps, useLocation } from "react-router-dom";

import { useAuth } from "../../hooks/auth";
import AccessDenied from "../AccessDenied";
import { buildLoginRedirectUrl } from "../../utils/authRedirect";

interface IPrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  /** Restricts access to the listed user types (e.g. ["proprietario"]). */
  requiredUserType?: string[];
  fallback?: React.ReactNode;
}

export default function PrivateRoute({
  component: Component,
  requiredUserType,
  fallback,
  ...rest
}: IPrivateRouteProps) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    const loginUrl = buildLoginRedirectUrl(
      location.pathname + location.search
    );
    return <Redirect to={loginUrl} />;
  }

  if (requiredUserType && requiredUserType.length > 0) {
    const hasRequiredType = requiredUserType.includes(user.type);

    if (!hasRequiredType) {
      return (
        <>
          {fallback ?? <AccessDenied />}
        </>
      );
    }
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
